"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireDefault(require("react"));
var _commonCta = require("@mmc/common-cta");
var _configuratorSecondaryNavigation = require("./configurator-secondary-navigation.props/configurator-secondary-navigation.propTypes");
var _configuratorSecondaryNavigation2 = _interopRequireDefault(require("../styles/configurator-secondary-navigation.css"));
var BackLink = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(BackLink, _React$Component);
  function BackLink(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }
  var _proto = BackLink.prototype;
  _proto.handleClick = function handleClick(e) {
    var _this$props = this.props,
      link = _this$props.link,
      activePhase = _this$props.activePhase;
    if (link.clickEvent) {
      link.clickEvent(e, activePhase);
    }
  };
  _proto.render = function render() {
    var _this$props2 = this.props,
      link = _this$props2.link,
      theme = _this$props2.theme;
    var ctaData = {
      label: link.label || '',
      priority: link.priority || 'trivial'
    };
    return /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
      data: ctaData,
      clickEvent: this.handleClick,
      classes: [_configuratorSecondaryNavigation2["default"].backButton],
      theme: theme
    });
  };
  return BackLink;
}(_react["default"].Component);
exports["default"] = BackLink;
BackLink.displayName = 'BackLink';